import { createSlice } from '@reduxjs/toolkit';
import type { TAdminUser, TRecruiterAppUser } from 'types/user.types';
import { isHubertAdminUser, isRecruiterUser } from 'types/user.types';

type configState = {
  isLoggedIn: boolean;
  user: TAdminUser | TRecruiterAppUser | null;
};

const initialState: configState = {
  isLoggedIn: false,
  user: null,
};

const ConfigSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setIsLoggedIn(state, action) {
      const { user } = action.payload;
      let u: TAdminUser | TRecruiterAppUser | null;

      if (isHubertAdminUser(user)) {
        u = {
          ...user,
          fullname: `${user.first_name} ${user.last_name}`,
        } as TAdminUser;
      } else if (isRecruiterUser(user)) {
        u = {
          ...user,
          fullname: `${user.first_name} ${user.last_name}`,
        } as TRecruiterAppUser;
      } else {
        u = null;
      }

      if (u) {
        return {
          ...state,
          user: u,
          isLoggedIn: true,
        };
      } else {
        return {
          ...state,
          isLoggedIn: false,
        };
      }
    },

    setIsLoggedOut(state) {
      return {
        ...state,
        user: null,
        isLoggedIn: false,
      };
    },
  },
});

export const { setIsLoggedIn, setIsLoggedOut } = ConfigSlice.actions;
export default ConfigSlice.reducer;
